import { useMemo, type ReactElement } from 'react';
import { encode } from 'uqr';

export interface QrCodeProps {
  value: string;
  /** Что закодировано — для экранного чтения: сама картинка ничего не говорит. */
  label: string;
  size?: number;
}

/**
 * QR-код ссылки. Нужен общему планшету кухни: ссылку на бота повар открывает не на
 * планшете, а на СВОЁМ телефоне, наведя камеру, — иначе Telegram привязался бы к тому,
 * кто залогинен на планшете в Telegram, а не к повару.
 *
 * Чёрным по белому при любой теме: сканер камеры тёмный QR на тёмном фоне не читает.
 * Все модули — одним `<path>`: сотни отдельных квадратов — лишняя работа рендеру ради
 * картинки, которая не меняется.
 */
export function QrCode({ value, label, size = 176 }: QrCodeProps): ReactElement {
  const { path, cells } = useMemo(() => {
    const qr = encode(value, { border: 2, ecc: 'M' });
    let d = '';
    qr.data.forEach((row, y) => {
      row.forEach((dark, x) => {
        if (dark) d += `M${x} ${y}h1v1h-1z`;
      });
    });
    return { path: d, cells: qr.data.length };
  }, [value]);

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${cells} ${cells}`}
      shapeRendering="crispEdges"
    >
      <rect width={cells} height={cells} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
